export default __webpack_public_path__ + "static/media/Thorin's Letter to Bilbo_08.2e929d01.jpg";